import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-geolocation-request-footer',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './geolocation-request-footer.component.html',
  styleUrls: ['./geolocation-request-footer.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeolocationRequestFooterComponent {
  public geolocationRequestEmitter = output<boolean>();

  protected handleRequestGeolocation(value: boolean): void {
    this.geolocationRequestEmitter.emit(value);
  }
}